export default __webpack_public_path__ + "static/media/terrain-icon.719f76c6.svg";